var i = /* @__PURE__ */ ((a) => (a.default = "default", a.luminous = "luminous", a.night = "night", a.camilla = "camilla", a.creamy = "creamy", a.sepia = "sepia", a.urban = "urban", a.solarized = "solarized", a.cosmopolitan = "cosmopolitan", a.new_york = "new_york", a.cyberpunk = "cyberpunk", a))(i || {});
export {
  i as StoreThemeEnum
};
